import { useQueryClient, useMutation } from '@tanstack/react-query';
import journeysQueryKeys from 'pages/TestJourneys/queries/keys';
import { journeyQueryKeys } from 'pages/SingleJourney/queries/keys';
import SingleJourneyService from '../services';

export function useReorderStepsMutation({ journeyId }) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (steps) => {
            return SingleJourneyService.changeJourneySteps({journeyId, steps});
        },
        onSuccess: () => {
            queryClient.invalidateQueries([journeysQueryKeys.journeyList, journeyId]);
            queryClient.invalidateQueries([journeyQueryKeys.singleJourney, journeyId]);
        },
    });
}

export function useDeleteStepMutation({ stepId, journeyId }) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () => {
            return SingleJourneyService.deleteJourneyStep({journeyId, stepId});
        },
        onSuccess: () => {
            queryClient.invalidateQueries([journeysQueryKeys.journeyList, journeyId]);
            queryClient.invalidateQueries([journeyQueryKeys.singleJourney, journeyId]);
        },
    });
}

export function useCreateGroupMutation({ stepIds, journeyId, onSuccess, onError }) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ label, description }) => {
            return SingleJourneyService.createGroup({ journeyId, stepIds, label, description });
        },
        onSuccess: (data) => {
            onSuccess?.(data)
            queryClient.invalidateQueries([journeysQueryKeys.journeyList, journeyId]);
            queryClient.invalidateQueries([journeyQueryKeys.singleJourney, journeyId]);
        },
        onError: (error) => {
            onError?.(error)
        }
    });
}
